import { createAction } from '@reduxjs/toolkit';
import {
  GetInitializeCommunication,
  InitializeCommunication,
  RequestError,
  SendCommunicationFirstStepForm,
  SendCommunicationFormValues,
  SendCommunicationSecondStepForm,
} from 'types';
import { State } from './types';
import { createActionWithCallback } from '../utils';

export const setIsBulkCommunication = createAction(
  'send-communication/set-is-bulk-communication',
  (isBulkCommunication: boolean) => ({
    payload: isBulkCommunication,
  })
);

export const fetchInitializeCommunication = createActionWithCallback<InitializeCommunication, Error>()(
  'send-communication/initialize-communication',
  (payload: GetInitializeCommunication) => ({
    payload,
  })
);

export const fetchedInitializeCommunication = createAction(
  'send-communication/initialize-communication-fetched',
  (data?: State['initializeCommunication']['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const submitStep1 = createAction(
  'send-communication/submit-step1',
  (formValues: SendCommunicationFirstStepForm) => ({
    payload: formValues,
  })
);

export const submitStep2 = createAction(
  'send-communication/submit-step2',
  (formValues: SendCommunicationSecondStepForm) => ({
    payload: formValues,
  })
);

export const saveCommunications = createActionWithCallback<void, Error>()(
  'send-communication/save',
  (formValues: SendCommunicationFormValues) => ({
    payload: formValues,
  })
);

export const fetchedSaveCommunications = createAction(
  'send-communication/fetchedSave',
  (data?: State['saveCommunication']['data'], error?: RequestError) => ({
    payload: { data, error },
    error: Boolean(error),
  })
);

export default {
  fetchInitializeCommunication,
  fetchedInitializeCommunication,
  submitStep1,
  submitStep2,
  saveCommunications,
  setIsBulkCommunication,
};
